import type { Distance, SpatialRectangle } from "@pdfking/math"
import type { PlotMedia } from "@pdfking/renderer-api"
import { PlotFunction } from "@pdfking/renderer-api"

export const CreateMedia = (
  position: SpatialRectangle<Distance>,
  opts: Partial<PlotMedia> = {}
) => ({
  enum: PlotFunction.PLOT_MEDIA as const,
  position,
  ...opts,
})
